/**
 * Countries + cities for /jobs location SEO pages (/jobs/categories,
 * Browse more jobs on country pages).
 *
 * City slugs are drawn from FindPagesConstants::CITIES_DATA in the API, but
 * this list is curated for display (no postal-district Dublin entries,
 * no misspellings, English city names where we have both forms, etc.).
 * Do not treat this as a 1:1 dump of the API constant.
 */

export const FIND_JOBS_LIST = [
  '3D Animator',
  'Animator',
  'Digital Marketer',
  'Graphic Designer',
  'Illustrator',
  'Mixing Engineer',
  'Motion Graphic Designer',
  'Music Composer',
  'Music Producer',
  'Photographer',
  'SEO Expert',
  'Social Media Freelancer',
  'UI Designer',
  'UX Designer',
  'Video Editor',
  'Videographer',
  'Vocalist',
  'Voiceover Artist',
  'Web Designer',
  'Web Developer',
];

export const FIND_COUNTRIES_WITH_CITIES = [
  {
    code: 'US',
    name: 'United States',
    slug: 'united-states',
    cities: [
      { slug: 'new-york', label: 'New York' },
      { slug: 'los-angeles', label: 'Los Angeles' },
      { slug: 'chicago', label: 'Chicago' },
      { slug: 'atlanta', label: 'Atlanta' },
      { slug: 'philadelphia', label: 'Philadelphia' },
      { slug: 'houston', label: 'Houston' },
      { slug: 'miami', label: 'Miami' },
      { slug: 'seattle', label: 'Seattle' },
      { slug: 'san-francisco', label: 'San Francisco' },
      { slug: 'dallas', label: 'Dallas' },
      { slug: 'austin', label: 'Austin' },
      { slug: 'boston', label: 'Boston' },
      { slug: 'denver', label: 'Denver' },
      { slug: 'portland', label: 'Portland' },
      { slug: 'san-diego', label: 'San Diego' },
      { slug: 'washington-dc', label: 'Washington DC' },
      { slug: 'phoenix', label: 'Phoenix' },
      { slug: 'detroit', label: 'Detroit' },
      { slug: 'minneapolis', label: 'Minneapolis' },
      { slug: 'charlotte', label: 'Charlotte' },
      { slug: 'las-vegas', label: 'Las Vegas' },
      { slug: 'orlando', label: 'Orlando' },
      { slug: 'tampa', label: 'Tampa' },
      { slug: 'nashville', label: 'Nashville' },
      { slug: 'new-orleans', label: 'New Orleans' },
      { slug: 'san-jose', label: 'San Jose' },
      { slug: 'baltimore', label: 'Baltimore' },
      { slug: 'st-louis', label: 'St. Louis' },
      { slug: 'pittsburgh', label: 'Pittsburgh' },
      { slug: 'cleveland', label: 'Cleveland' },
      { slug: 'indianapolis', label: 'Indianapolis' },
      { slug: 'columbus', label: 'Columbus' },
      { slug: 'kansas-city', label: 'Kansas City' },
      { slug: 'sacramento', label: 'Sacramento' },
      { slug: 'salt-lake-city', label: 'Salt Lake City' },
    ],
  },
  {
    code: 'UK',
    name: 'United Kingdom',
    slug: 'united-kingdom',
    cities: [
      { slug: 'london', label: 'London' },
      { slug: 'manchester', label: 'Manchester' },
      { slug: 'bristol', label: 'Bristol' },
      { slug: 'edinburgh', label: 'Edinburgh' },
      { slug: 'birmingham', label: 'Birmingham' },
      { slug: 'glasgow', label: 'Glasgow' },
      { slug: 'leeds', label: 'Leeds' },
      { slug: 'nottingham', label: 'Nottingham' },
      { slug: 'liverpool', label: 'Liverpool' },
      { slug: 'cardiff', label: 'Cardiff' },
      { slug: 'sheffield', label: 'Sheffield' },
      { slug: 'brighton', label: 'Brighton' },
      { slug: 'newcastle-upon-tyne', label: 'Newcastle upon Tyne' },
      { slug: 'leicester', label: 'Leicester' },
      { slug: 'norwich', label: 'Norwich' },
    ],
  },
  {
    code: 'IT',
    name: 'Italy',
    slug: 'italy',
    cities: [
      { slug: 'milan', label: 'Milan' },
      { slug: 'naples', label: 'Naples' },
      { slug: 'bologna', label: 'Bologna' },
      { slug: 'rome', label: 'Rome' },
      { slug: 'florence', label: 'Florence' },
      { slug: 'turin', label: 'Turin' },
      { slug: 'palermo', label: 'Palermo' },
      { slug: 'catania', label: 'Catania' },
      { slug: 'bari', label: 'Bari' },
      { slug: 'genoa', label: 'Genoa' },
    ],
  },
  {
    code: 'CA',
    name: 'Canada',
    slug: 'canada',
    cities: [
      { slug: 'toronto', label: 'Toronto' },
      { slug: 'vancouver', label: 'Vancouver' },
      { slug: 'montreal', label: 'Montreal' },
      { slug: 'calgary', label: 'Calgary' },
      { slug: 'ottawa', label: 'Ottawa' },
      { slug: 'edmonton', label: 'Edmonton' },
      { slug: 'mississauga', label: 'Mississauga' },
      { slug: 'kitchener', label: 'Kitchener' },
      { slug: 'brampton', label: 'Brampton' },
      { slug: 'london', label: 'London' },
      { slug: 'hamilton', label: 'Hamilton' },
      { slug: 'winnipeg', label: 'Winnipeg' },
      { slug: 'surrey', label: 'Surrey' },
      { slug: 'halifax', label: 'Halifax' },
      { slug: 'waterloo', label: 'Waterloo' },
    ],
  },
  {
    code: 'AU',
    name: 'Australia',
    slug: 'australia',
    cities: [
      { slug: 'melbourne', label: 'Melbourne' },
      { slug: 'sydney', label: 'Sydney' },
      { slug: 'perth', label: 'Perth' },
      { slug: 'brisbane', label: 'Brisbane' },
      { slug: 'adelaide', label: 'Adelaide' },
      { slug: 'gold-coast', label: 'Gold Coast' },
      { slug: 'newcastle', label: 'Newcastle' },
      { slug: 'canberra', label: 'Canberra' },
      { slug: 'sunshine-coast', label: 'Sunshine Coast' },
      { slug: 'hobart', label: 'Hobart' },
      { slug: 'byron-bay', label: 'Byron Bay' },
    ],
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    slug: 'united-arab-emirates',
    cities: [
      { slug: 'dubai', label: 'Dubai' },
      { slug: 'abu-dhabi', label: 'Abu Dhabi' },
      { slug: 'sharjah', label: 'Sharjah' },
      { slug: 'ajman', label: 'Ajman' },
      { slug: 'al-ain', label: 'Al Ain' },
      { slug: 'ras-al-khaimah', label: 'Ras Al Khaimah' },
      { slug: 'fujairah', label: 'Fujairah' },
    ],
  },
  {
    code: 'DE',
    name: 'Germany',
    slug: 'germany',
    cities: [
      { slug: 'berlin', label: 'Berlin' },
      { slug: 'hamburg', label: 'Hamburg' },
      { slug: 'munich', label: 'Munich' },
      { slug: 'cologne', label: 'Cologne' },
      { slug: 'frankfurt', label: 'Frankfurt' },
      { slug: 'stuttgart', label: 'Stuttgart' },
      { slug: 'duesseldorf', label: 'Dusseldorf' },
      { slug: 'leipzig', label: 'Leipzig' },
      { slug: 'dresden', label: 'Dresden' },
      { slug: 'bremen', label: 'Bremen' },
    ],
  },
  {
    code: 'MY',
    name: 'Malaysia',
    slug: 'malaysia',
    cities: [
      { slug: 'kuala-lumpur', label: 'Kuala Lumpur' },
      { slug: 'johor-bahru', label: 'Johor Bahru' },
      { slug: 'george-town', label: 'George Town' },
      { slug: 'kota-kinabalu', label: 'Kota Kinabalu' },
      { slug: 'subang-jaya', label: 'Subang Jaya' },
      { slug: 'ipoh', label: 'Ipoh' },
      { slug: 'penang', label: 'Penang' },
    ],
  },
  {
    code: 'NL',
    name: 'Netherlands',
    slug: 'netherlands',
    cities: [
      { slug: 'amsterdam', label: 'Amsterdam' },
      { slug: 'rotterdam', label: 'Rotterdam' },
      { slug: 'the-hague', label: 'The Hague' },
      { slug: 'utrecht', label: 'Utrecht' },
      { slug: 'eindhoven', label: 'Eindhoven' },
      { slug: 'groningen', label: 'Groningen' },
      { slug: 'haarlem', label: 'Haarlem' },
      { slug: 'almere', label: 'Almere' },
      { slug: 'breda', label: 'Breda' },
      { slug: 'delft', label: 'Delft' },
      { slug: 'maastricht', label: 'Maastricht' },
      { slug: 'arnhem', label: 'Arnhem' },
    ],
  },
  {
    code: 'IE',
    name: 'Ireland',
    slug: 'ireland',
    cities: [
      { slug: 'dublin', label: 'Dublin' },
      { slug: 'cork', label: 'Cork' },
      { slug: 'galway', label: 'Galway' },
      { slug: 'limerick', label: 'Limerick' },
      { slug: 'kildare', label: 'Kildare' },
      { slug: 'sligo', label: 'Sligo' },
    ],
  },
  {
    code: 'ES',
    name: 'Spain',
    slug: 'spain',
    cities: [
      { slug: 'barcelona', label: 'Barcelona' },
      { slug: 'madrid', label: 'Madrid' },
      { slug: 'valencia', label: 'Valencia' },
      { slug: 'malaga', label: 'Malaga' },
      { slug: 'sevilla', label: 'Seville' },
      { slug: 'palma', label: 'Palma' },
      { slug: 'zaragoza', label: 'Zaragoza' },
      { slug: 'alicante', label: 'Alicante' },
      { slug: 'murcia', label: 'Murcia' },
      { slug: 'bilbao', label: 'Bilbao' },
    ],
  },
  {
    code: 'FR',
    name: 'France',
    slug: 'france',
    cities: [
      { slug: 'paris', label: 'Paris' },
      { slug: 'lyon', label: 'Lyon' },
      { slug: 'bordeaux', label: 'Bordeaux' },
      { slug: 'toulouse', label: 'Toulouse' },
      { slug: 'marseille', label: 'Marseille' },
      { slug: 'montpellier', label: 'Montpellier' },
      { slug: 'nantes', label: 'Nantes' },
      { slug: 'lille', label: 'Lille' },
      { slug: 'strasbourg', label: 'Strasbourg' },
      { slug: 'nice', label: 'Nice' },
    ],
  },
  {
    code: 'PT',
    name: 'Portugal',
    slug: 'portugal',
    cities: [
      { slug: 'porto', label: 'Porto' },
      { slug: 'lisbon', label: 'Lisbon' },
      { slug: 'braga', label: 'Braga' },
      { slug: 'aveiro', label: 'Aveiro' },
      { slug: 'faro', label: 'Faro' },
      { slug: 'coimbra', label: 'Coimbra' },
      { slug: 'setubal', label: 'Setubal' },
      { slug: 'funchal', label: 'Funchal' },
      { slug: 'cascais', label: 'Cascais' },
      { slug: 'vila-nova-de-gaia', label: 'Vila Nova de Gaia' },
    ],
  },
  {
    code: 'TH',
    name: 'Thailand',
    slug: 'thailand',
    cities: [
      { slug: 'bangkok', label: 'Bangkok' },
      { slug: 'chiang-mai', label: 'Chiang Mai' },
      { slug: 'phuket', label: 'Phuket' },
      { slug: 'pattaya-city', label: 'Pattaya' },
    ],
  },
  {
    code: 'SE',
    name: 'Sweden',
    slug: 'sweden',
    cities: [
      { slug: 'stockholm', label: 'Stockholm' },
      { slug: 'gothenburg', label: 'Gothenburg' },
      { slug: 'malmo', label: 'Malmo' },
      { slug: 'uppsala', label: 'Uppsala' },
      { slug: 'helsingborg', label: 'Helsingborg' },
      { slug: 'vasteras', label: 'Vasteras' },
      { slug: 'linkoping', label: 'Linkoping' },
      { slug: 'orebro', label: 'Orebro' },
      { slug: 'jonkoping', label: 'Jonkoping' },
      { slug: 'norrkoping', label: 'Norrkoping' },
    ],
  },
  {
    code: 'CH',
    name: 'Switzerland',
    slug: 'switzerland',
    cities: [
      { slug: 'zurich', label: 'Zurich' },
      { slug: 'lausanne', label: 'Lausanne' },
      { slug: 'bern', label: 'Bern' },
      { slug: 'basel', label: 'Basel' },
      { slug: 'geneva', label: 'Geneva' },
      { slug: 'lugano', label: 'Lugano' },
      { slug: 'winterthur', label: 'Winterthur' },
      { slug: 'lucerne', label: 'Lucerne' },
      { slug: 'st-gallen', label: 'St. Gallen' },
      { slug: 'biel', label: 'Biel' },
    ],
  },
  {
    code: 'JP',
    name: 'Japan',
    slug: 'japan',
    cities: [
      { slug: 'tokyo', label: 'Tokyo' },
      { slug: 'osaka', label: 'Osaka' },
      { slug: 'yokohama', label: 'Yokohama' },
      { slug: 'nagoya', label: 'Nagoya' },
      { slug: 'kyoto', label: 'Kyoto' },
      { slug: 'fukuoka', label: 'Fukuoka' },
      { slug: 'kawasaki', label: 'Kawasaki' },
      { slug: 'saitama', label: 'Saitama' },
      { slug: 'hiroshima', label: 'Hiroshima' },
      { slug: 'sendai', label: 'Sendai' },
    ],
  },
  {
    code: 'AR',
    name: 'Argentina',
    slug: 'argentina',
    cities: [
      { slug: 'buenos-aires', label: 'Buenos Aires' },
      { slug: 'cordoba', label: 'Cordoba' },
      { slug: 'rosario', label: 'Rosario' },
      { slug: 'salta', label: 'Salta' },
    ],
  },
  {
    code: 'AT',
    name: 'Austria',
    slug: 'austria',
    cities: [
      { slug: 'vienna', label: 'Vienna' },
      { slug: 'graz', label: 'Graz' },
      { slug: 'innsbruck', label: 'Innsbruck' },
      { slug: 'salzburg', label: 'Salzburg' },
      { slug: 'linz', label: 'Linz' },
      { slug: 'wiener-neustadt', label: 'Wiener Neustadt' },
    ],
  },
  {
    code: 'BE',
    name: 'Belgium',
    slug: 'belgium',
    cities: [
      { slug: 'brussels', label: 'Brussels' },
      { slug: 'antwerp', label: 'Antwerp' },
      { slug: 'leuven', label: 'Leuven' },
      { slug: 'ghent', label: 'Ghent' },
    ],
  },
  {
    code: 'BR',
    name: 'Brazil',
    slug: 'brazil',
    cities: [
      { slug: 'sao-paulo', label: 'Sao Paulo' },
      { slug: 'rio-de-janeiro', label: 'Rio de Janeiro' },
      { slug: 'brasilia', label: 'Brasilia' },
      { slug: 'curitiba', label: 'Curitiba' },
      { slug: 'belo-horizonte', label: 'Belo Horizonte' },
      { slug: 'porto-alegre', label: 'Porto Alegre' },
      { slug: 'salvador', label: 'Salvador' },
      { slug: 'recife', label: 'Recife' },
      { slug: 'fortaleza', label: 'Fortaleza' },
      { slug: 'manaus', label: 'Manaus' },
    ],
  },
  {
    code: 'DK',
    name: 'Denmark',
    slug: 'denmark',
    cities: [
      { slug: 'copenhagen', label: 'Copenhagen' },
      { slug: 'aarhus', label: 'Aarhus' },
      { slug: 'aalborg', label: 'Aalborg' },
      { slug: 'esbjerg', label: 'Esbjerg' },
    ],
  },
  {
    code: 'FI',
    name: 'Finland',
    slug: 'finland',
    cities: [
      { slug: 'helsinki', label: 'Helsinki' },
      { slug: 'tampere', label: 'Tampere' },
      { slug: 'turku', label: 'Turku' },
      { slug: 'espoo', label: 'Espoo' },
      { slug: 'oulu', label: 'Oulu' },
      { slug: 'vaasa', label: 'Vaasa' },
      { slug: 'vantaa', label: 'Vantaa' },
    ],
  },
  {
    code: 'GR',
    name: 'Greece',
    slug: 'greece',
    cities: [
      { slug: 'athens', label: 'Athens' },
      { slug: 'thessaloniki', label: 'Thessaloniki' },
      { slug: 'larissa', label: 'Larissa' },
    ],
  },
  {
    code: 'HR',
    name: 'Croatia',
    slug: 'croatia',
    cities: [
      { slug: 'zagreb', label: 'Zagreb' },
      { slug: 'split', label: 'Split' },
      { slug: 'rijeka', label: 'Rijeka' },
      { slug: 'osijek', label: 'Osijek' },
      { slug: 'zadar', label: 'Zadar' },
      { slug: 'dubrovnik', label: 'Dubrovnik' },
    ],
  },
  {
    code: 'IN',
    name: 'India',
    slug: 'india',
    cities: [
      { slug: 'mumbai', label: 'Mumbai' },
      { slug: 'bengaluru', label: 'Bengaluru' },
      { slug: 'delhi', label: 'Delhi' },
      { slug: 'kolkata', label: 'Kolkata' },
      { slug: 'pune', label: 'Pune' },
      { slug: 'ahmedabad', label: 'Ahmedabad' },
      { slug: 'hyderabad', label: 'Hyderabad' },
      { slug: 'jaipur', label: 'Jaipur' },
      { slug: 'chennai', label: 'Chennai' },
      { slug: 'surat', label: 'Surat' },
      { slug: 'gurugram', label: 'Gurugram' },
    ],
  },
  {
    code: 'MX',
    name: 'Mexico',
    slug: 'mexico',
    cities: [
      { slug: 'mexico-city', label: 'Mexico City' },
      { slug: 'guadalajara', label: 'Guadalajara' },
      { slug: 'tijuana', label: 'Tijuana' },
      { slug: 'leon', label: 'Leon' },
    ],
  },
  {
    code: 'NO',
    name: 'Norway',
    slug: 'norway',
    cities: [
      { slug: 'oslo', label: 'Oslo' },
      { slug: 'bergen', label: 'Bergen' },
      { slug: 'trondheim', label: 'Trondheim' },
    ],
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    slug: 'new-zealand',
    cities: [
      { slug: 'auckland', label: 'Auckland' },
      { slug: 'wellington', label: 'Wellington' },
      { slug: 'christchurch', label: 'Christchurch' },
      { slug: 'hamilton', label: 'Hamilton' },
      { slug: 'tauranga', label: 'Tauranga' },
      { slug: 'dunedin', label: 'Dunedin' },
      { slug: 'napier', label: 'Napier' },
      { slug: 'nelson', label: 'Nelson' },
      { slug: 'queenstown', label: 'Queenstown' },
      { slug: 'rotorua', label: 'Rotorua' },
    ],
  },
  {
    code: 'PL',
    name: 'Poland',
    slug: 'poland',
    cities: [
      { slug: 'krakow', label: 'Krakow' },
      { slug: 'warsaw', label: 'Warsaw' },
      { slug: 'wroclaw', label: 'Wroclaw' },
      { slug: 'poznan', label: 'Poznan' },
      { slug: 'gdansk', label: 'Gdansk' },
      { slug: 'lodz', label: 'Lodz' },
    ],
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    slug: 'saudi-arabia',
    cities: [
      { slug: 'riyadh', label: 'Riyadh' },
      { slug: 'jeddah', label: 'Jeddah' },
      { slug: 'dammam', label: 'Dammam' },
    ],
  },
];

/** Country display names (same order as FIND_COUNTRIES_WITH_CITIES). */
export const FIND_COUNTRIES_LIST = FIND_COUNTRIES_WITH_CITIES.map(
  (country) => country.name
);

export const BROWSE_MORE_JOBS_CITY_LIMIT = 5;

/**
 * Look up a FIND_COUNTRIES_WITH_CITIES entry by SEO slug or display name
 * (e.g. "united-states" or "United States").
 */
export function getFindCountryBySlug(countryKey) {
  if (!countryKey) {
    return null;
  }
  const normalized = String(countryKey)
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return (
    FIND_COUNTRIES_WITH_CITIES.find((country) => country.slug === normalized) ||
    null
  );
}
